import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import { normalizeDescription } from 'seagull/utils/richText';
import { getTestIds } from 'seagull/utils/TestIds';
import { TemplateVariablesProvider } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import ServiceDescription from '~/components/ServiceBuilder/ServiceDescription/ServiceDescription';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { PersistTemplateVariableValues } from '../PersistTemplateVariableValues';
const EMPTY_TEXT_FIELDS = [];
export const GetServiceDescriptionModalContentTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ServiceDescriptionModalContentTID: {
                Description: 'edit-service-description-modal'
            }
        }
    });
export const GetServiceDescriptionCellTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ServiceDescriptionCellTID: {
                Cell: (index, draftId)=>"edit-service-description-".concat(index, "-").concat(draftId),
                Description: (index, draftId)=>"service-description-".concat(index, "-").concat(draftId),
                Modal: 'edit-service-description-modal'
            }
        }
    });
export const ServiceDescriptionModalContent = (param)=>{
    let { service, draft, setDraft, contact, worksAt } = param;
    const form = useForm({
        mode: 'all',
        defaultValues: {
            description: service.description
        }
    });
    const { ServiceDescriptionModalContentTID } = useMemo(()=>GetServiceDescriptionModalContentTID(), []);
    const richTextFields = useMemo(()=>[
            service.description
        ], [
        service.description
    ]);
    const onChange = (description)=>{
        setDraft((prev)=>prev.setService(service.id, (s)=>_object_spread_props(_object_spread({}, s), {
                    description: normalizeDescription(description)
                })));
    };
    return /*#__PURE__*/ _jsxs(TemplateVariablesProvider, {
        contact: contact,
        worksAt: worksAt,
        agreementName: draft.title(),
        effectiveDate: draft.effectiveDateAsDate(),
        initialTemplateVariableValues: draft.templateVariableValues(),
        textFields: EMPTY_TEXT_FIELDS,
        richTextFields: richTextFields,
        children: [
            /*#__PURE__*/ _jsx(PersistTemplateVariableValues, {
                setDraft: setDraft
            }),
            /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
                children: /*#__PURE__*/ _jsx(ServiceDescription, {
                    testId: ServiceDescriptionModalContentTID.Description(),
                    hideLabel: true,
                    onChange: onChange
                })
            }))
        ]
    });
};
export default function ServiceDescriptionCell(param) {
    let { index, draft, service, onOpenModal, isDisabled, disabledTooltip, contact, worksAt } = param;
    const { t: serviceCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.serviceCells');
    const { ServiceDescriptionCellTID } = useMemo(()=>GetServiceDescriptionCellTID(), []);
    const onClick = ()=>{
        onOpenModal({
            shouldSubmit: async (draft)=>{
                var _draft_services_find, _serviceBundles_services_find;
                const serviceDescription = (_draft_services_find = draft.services().find((s)=>s.id === service.id)) === null || _draft_services_find === void 0 ? void 0 : _draft_services_find.description;
                const serviceBundles = draft.serviceBundles().find((b)=>b.services.find((s)=>s.id === service.id));
                const serviceBundlesDescription = serviceBundles === null || serviceBundles === void 0 ? void 0 : (_serviceBundles_services_find = serviceBundles.services.find((s)=>s.id === service.id)) === null || _serviceBundles_services_find === void 0 ? void 0 : _serviceBundles_services_find.description;
                return Promise.resolve(!!serviceDescription && serviceDescription !== service.description || !!serviceBundlesDescription && serviceBundlesDescription !== service.description);
            },
            renderContent: (param)=>{
                let { setDraft } = param;
                return {
                    title: serviceCellsTexts.serviceDescription(),
                    testId: ServiceDescriptionCellTID.Modal(),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(ServiceDescriptionModalContent, {
                        service: service,
                        draft: draft,
                        setDraft: setDraft,
                        contact: contact,
                        worksAt: worksAt
                    })
                };
            }
        });
    };
    const pureText = useMemo(()=>extractPureTextFromRichText(service.description), [
        service.description
    ]);
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: ServiceDescriptionCellTID.Cell(index, draft.id()),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: ServiceDescriptionCellTID.Description(index, draft.id()),
            ellipsis: true,
            children: pureText
        })
    });
}
